import { render, staticRenderFns } from "./Full.vue?vue&type=template&id=016ac51e&"
import script from "./Full.vue?vue&type=script&lang=js&"
export * from "./Full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Full.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/containers/Full.vue
// module id = null
// module chunks = 